export default {
  orderBaseCurrenciesTitle: "ارز پایه :",
  avatar: {
    status: "وضعیت",
    unverified: "احراز هویت نشده"
  },
  menu: {
    dashborad: "داشبورد",
    wallet: {
      wallet: "کیف پول",
      main: "اصلی",
      mainDetail: "واریز، برداشت",
      spot: "اسپات (مارکت)",
      spotDetail: "کیف پول اسپات",
      transfer: {
        transfer: "انتقال",
        transferDetail: "انتقال دارایی بین کیف پول اصلی و اسپات",
        transferToMain: "اسپات به اصلی",
        transfertToMainDetail: "انتقال دارایی ها ",
        transferToSpot: "اصلی به اسپات",
        transfertToSpotDetail: "انتقال دارایی ها "
      }
    },

    dealing: {
      dealing: "معامله",
      fastConvert: "تبدیل سریع",
      fastConvertDetail: "تبدیل یک ارز به ارز دیگر",
      spot: "اسپات (مارکت)",
      spotDetail: "معامله P2P",
      ordering: "سفارش گذاری",
      orderingDetail: "ثبت سفارش در OTC",
      testMarket: "اسپات آزمایشی (دمو)",
      testMarketDetail: "معامله دمو P2P",
      perfectMoney: "پرفکت مانی",
      perfectMoneyDetail: "خرید و فروش پرفکت مانی",
      withdrawHistory: "تاریخچه برداشت",
      depositHistory: "تاریخچه واریز"
    },
    api_management: "مدیریت API",
    markets: "بازارها",
    prices: "لیست ارزها",
    orders: {
      orders: "سفارشات",
      openOrders: "سفارشات باز (اسپات)",
      openOrdersDetail: "سفارشات باز شما",
      profitLossLimit: "حد سود و ضرر (اسپات)",
      profitLossLimitDetail: "سفارشات حد سود و ضرر شما",
      history: {
        history: "تاریخچه",
        historyDetail: "تاریخچه همه سفارشات",
        openOrders: "سفارشات (اسپات)",
        openOrdersDetail: "تاریخچه سفارشات",
        profitLossLimit: "حد سود و ضرر (اسپات)",
        profitLossLimitDetail: "تاریخچه حد سود و ضرر",
        otc: "تبدیل سریع و سفارش گذاری",
        otcDetail: "تاریخچه سفارشات OTC",
        transactions: "تراکنش‌ها (اسپات)",
        transactionsDetail: "تاریخچه معاملات"
      }
    },
    investing: {
      investing: "سرمایه‌گذاری",
      staking: "استیکینگ",
      stakingDetail: "طرح‌های استیکینگ و مشارکت",
      partnershipFunds: "صندوق‌های مشارکت",
      partnershipFundsDetail: "طرح‌های صندوق‌های مشارکت",
      uranus: "طرح اورانوس",
      uranusDetail: "طرح سرمایه گذاری اورانوس"
    },
    gateway: "درگاه رمزارز",
    blog: "بلاگ"
  },
  navigationDrawer: [
    {
      to: "/dashboard",
      tooltip: "داشبورد",
      icon: "$vuetify.CustomIcon.dashboardIcon"
    },
    {
      to: "/wallet/main",
      tooltip: "کیف پول",
      icon: "$vuetify.CustomIcon.walletIcon"
    },
    {
      to: "/operations/exchange?from=",
      tooltip: "تبدیل سریع",
      icon: "$vuetify.CustomIcon.exchangeIcon"
    },
    // {
    //   to: process.env.VUE_APP_MARKET_BASE_URL,
    //   tooltip: " اکسکوینو مارکت",
    //   icon: "$vuetify.CustomIcon.marketLogo",
    //   customLink: true
    // },
    {
      to: `/exchange/v-btc_v-usdt`,
      tooltip: "بازار آزمایشی",
      icon: "$vuetify.CustomIcon.demoTrading",
    },
    {
      to: "/order",
      tooltip: "سفارش گذاری",
      icon: "$vuetify.CustomIcon.newTradeIcon"
    },
    {
      to: "https://hello.excoino.com/fund/",
      tooltip: "سرمایه گذاری",
      icon: "$vuetify.CustomIcon.investment",
      customLink: true
    },
    {
      to: "/prices",
      tooltip: "قیمت ارزها",
      icon: "$vuetify.CustomIcon.priceList"
    },
    {
      to: "/history/transaction",
      tooltip: "تاریخچه تراکنش‌ها",
      icon: "$vuetify.CustomIcon.orderHistoryIcon"
    },
    {
      to: "/gifts",
      tooltip: "هدایا",
      icon: "$vuetify.CustomIcon.giftIcon"
    },
    // {
    //   to: "/panel/referral",
    //   tooltip: "دعوت دوستان",
    //   icon: "$vuetify.CustomIcon.referral"
    // },
    {
      to: "/tickets",
      tooltip: "تیکت پشتیبانی",
      icon: "$vuetify.CustomIcon.supportIcon"
    }
  ],
  market: {
    tooltip: "اکسکوینو مارکت"
  },
  exit: {
    tooltip: "خروج"
  },
  changeTheme: {
    tooltip: "تغییر رنگ قالب"
  }
};
